import rg4js from "raygun4js";
import { useEffect, useContext } from "react";
import { RaygunContext } from "@/providers/RaygunProvider";
import useCurrentUser from "@/hooks/useCurrentUser";

export default function useRaygun() {
  const { raygunBooted, raygunApiKey } = useContext(RaygunContext);
  const { user } = useCurrentUser();

  useEffect(() => {
    if (!raygunApiKey || !raygunBooted) return;

    rg4js("setUser", {
      identifier: user.email,
      isAnonymous: false
    });
  }, [user, raygunBooted, raygunApiKey]);
}
